export default import.meta.ROLLUP_FILE_URL_9GWxdQSL8APVRId5VtF7YQ